import { combineReducers } from "@reduxjs/toolkit";
import updateUser from '../features/user/userSlice';

// Root per tutti i reducers.
const rootReducer = combineReducers({
    updateUser
});

export default rootReducer;
